import { useQuery } from '@tanstack/react-query';
import { fetchAirQualityMeasurementGraph, fetchAirQualityStatistic } from '../apis/air-stats';
import type { AirSensorType } from '../types/air-stats.types';

const useAirStats = ({ params = '', sensorType }: { params?: string; sensorType: AirSensorType }) => {
  const { data: statisticData } = useQuery({
    queryKey: ['airQualityStatistic', sensorType, params],
    queryFn: () => fetchAirQualityStatistic(sensorType, params),
    staleTime: 1000 * 60 * 1,
  });

  const { data: graphData } = useQuery({
    queryKey: ['airQualityMeasurementGraph', sensorType, params],
    queryFn: () => fetchAirQualityMeasurementGraph(sensorType, params),
    staleTime: 1000 * 60 * 1,
  });

  return {
    rows: statisticData?.data?.rows,
    total: statisticData?.data?.total,
    metrics: graphData?.data?.metrics,
  };
};

export default useAirStats;
